import { render, staticRenderFns } from "./WorkflowCreateAndEditStatusDialog.vue?vue&type=template&id=62161810"
import script from "./WorkflowCreateAndEditStatusDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowCreateAndEditStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
